module.exports = __webpack_public_path__ + "static/case_09-0f803e611524aae254783e6f1d064ffa.jpg";